"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiEventCalendar = void 0;
const daygrid_1 = __importDefault(require("@fullcalendar/daygrid"));
const react_1 = __importDefault(require("@fullcalendar/react"));
const timegrid_1 = __importDefault(require("@fullcalendar/timegrid"));
const react_2 = __importStar(require("react"));
const configContext_1 = require("../../context/configContext");
const CustomerBooking_1 = require("../../models/CustomerBooking");
const Spinner_1 = require("../spinner/Spinner");
require("./Calendar.scss");
const deLocale = require("@fullcalendar/core/locales/de");
/**
 * Calendar for multiple events and multiple resources.
 */
const MultiEventCalendar = (props) => {
    const calendarComponentRef = (0, react_2.useRef)(null);
    const config = (0, configContext_1.useConfig)();
    (0, react_2.useEffect)(() => {
        let view = "day";
        switch (props.view) {
            case "day":
                view = "timeGridDay";
                break;
            case "week":
                view = "timeGridWeek";
                break;
            case "month":
                view = "dayGridMonth";
                break;
        }
        calendarComponentRef.current.getApi().changeView(view, props.date);
    }, [props.view, props.date]);
    const resourceColors = config.resources.map((resource) => ({
        id: resource.id,
        color: resource.color,
    }));
    const events = props.bookings.map((booking) => {
        var _a;
        const resourceColor = resourceColors.find((resourceColor) => resourceColor.id === booking.getResourceId());
        let title;
        if (booking instanceof CustomerBooking_1.CustomerBooking) {
            title = `${booking.title} (${booking.contact.name})`;
        }
        else {
            title =
                `${booking.title}` +
                    (booking.createdBy ? ` (${booking.createdBy.name})` : "");
        }
        return {
            id: booking.id,
            start: booking.start,
            end: booking.end,
            title: title,
            extendedProps: {
                booking: booking,
            },
            // textColor: "#222",
            backgroundColor: (_a = resourceColor === null || resourceColor === void 0 ? void 0 : resourceColor.color) !== null && _a !== void 0 ? _a : "#999",
            // borderColor: resourceColor?.color ?? "#999",
            editable: false,
        };
    });
    return (react_2.default.createElement("div", { className: "multi-event-calendar calendar-wrapper" },
        react_2.default.createElement(react_1.default, { ref: calendarComponentRef, defaultView: "timeGridWeek", header: false, titleFormat: { year: "numeric", month: "short", day: "numeric" }, locale: deLocale, allDaySlot: false, minTime: "06:00", maxTime: "24:00", contentHeight: () => {
                if (calendarComponentRef.current) {
                    const width = calendarComponentRef.current.getApi().el.clientWidth;
                    if (width > 800) {
                        return 780;
                    }
                    else if (width > 450) {
                        return width / 1.2;
                    }
                    else {
                        return width / 1;
                    }
                }
                else {
                    return 600;
                }
            }, scrollTime: "07:30", displayEventTime: true, displayEventEnd: true, timeZone: "local", defaultDate: props.date, validRange: { start: props.minDate, end: props.maxDate }, plugins: [daygrid_1.default, timegrid_1.default], events: events, eventClick: (info) => {
                props.onBookingClick(info.event.extendedProps.booking);
            } }),
        props.isBookingsLoading && (react_2.default.createElement("div", { className: "calendar-loading" },
            react_2.default.createElement(Spinner_1.Spinner, { className: "my-3 mx-auto" }),
            react_2.default.createElement("div", null, "Buchungen werden geladen...")))));
};
exports.MultiEventCalendar = MultiEventCalendar;
